import NotFoundPage from "@/pages/NotFoundPage";
import { ConfigProvider } from "antd";
import { Outlet, Route, Routes } from "react-router-dom";
import "@/projects/IPO/styles/style.css";
import routes from "@/projects/IPO/utils/routes";
import IPOProtectedRouter from "./auth/ProtectedRouter";

const IPOApp = () => {
  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];

  return (
    <ConfigProvider
      theme={{
        hashed: false,
      }}
      componentSize="large"
    >
      <div className="ipo-user-app" style={{ height: "48px" }}>
        <Routes>
          <Route element={<Outlet />}>
            {publicRoutes.map(({ path, component: Page }) => (
              <Route key={path} path={path} element={<Page />} />
            ))}
            <Route element={<IPOProtectedRouter />}>
              {authRoutes.map(({ path, component: Page }) => (
                <Route key={path} path={path} element={<Page />} />
              ))}
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </div>
    </ConfigProvider>
  );
};

export default IPOApp;
